import api from './api'
import moment from 'moment'

export const getAllEmployersInCurrentUnit = async unitId => {
  const {
    data: { data: employers },
  } = await api({
    method: 'get',
    url: `api/crm/unit/${unitId}/schedules`,
    params: {
      begin_at: moment().format('YYYY-MM-DD 00:00:00'),
      end_at: moment().format('YYYY-MM-DD 23:59:00'),
    },
  })

  return employers
}

export const getAllEmployersSchedules = async ({ unitId, selectedDate }) => {
  const {
    data: {
      data: { items: employersSchedules },
    },
  } = await api({
    method: 'get',
    url: 'api/crm/employers/schedules/no-window',
    params: {
      date: moment(selectedDate).format('YYYY-MM-DD'),
      unit_id: unitId,
    },
  })

  return employersSchedules
}

export const getCurrentBookingsWithWrongStatuses = async unitId => {
  const {
    data: { data: bookings },
  } = await api({
    method: 'get',
    url: `api/crm/unit/${unitId}/wrong-bookings`,
  })

  return bookings
}
